@if (showSpinner) {
  <div class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>{{ isSaving ? 'Submitting...' : 'Loading...' }}</p>
  </div>
}
<div
  fxLayout="column"
  fxLayoutAlign="center center"
  [fxHide]="showSpinner"
  class="survey neutral-theme"
>
  <div class="title-container" fxLayout="column" fxLayoutAlign="center center">
    @if (!inPreviewMode && form.formType == 'Team') {
      <div class="team-name">
        {{
          application?.publicTeamName
            ? application?.publicTeamName
            : application?.teamName
        }}
      </div>
    }
    <h1>{{ form?.displayTitle }}</h1>
  </div>
  @if (isIntroductionVisible && isAppLoaded()) {
    <div
      class="introduction-text"
      [innerHTML]="form?.introduction | safeHtml"
    ></div>
    <button
      mat-flat-button
      color="primary"
      class="start-button"
      (click)="startApplication()"
    >
      Next <mat-icon>arrow_forward</mat-icon>
    </button>
  }
  <div aria-live="assertive" aria-atomic="true" class="cdk-visually-hidden">
    {{ stepAnnouncement }}
  </div>
  <div
    class="main-container"
    [ngClass]="{ 'd-none': isIntroductionVisible || !isAppLoaded() }"
  >
    <span class="instructions"
      >Please complete or update the contact information below. Items marked
      with <span class="required">*</span> are required.</span
    >

    <mat-stepper
      linear
      class="stepper"
      #stepper
      (selectionChange)="stepperChange($event)"
      (animationDone)="onStepAnimationDone()"
    >
      @for (page of formPages; track page.id; let i = $index) {
        <mat-step [completed]="isPageValid(page)">
          <h2 class="font-24 mb-20">
            {{ page.name }}
          </h2>

          @if (page.description) {
            <span [innerHTML]="page.description | safeHtml"></span>
          }

          @if (page.pageNumber === 1) {
            @if (isCreateTeam) {
              <form [formGroup]="teamGroup">
                <div fxLayout="column">
                  <div
                    fxLayout="column"
                    fxLayoutGap="10px"
                    class="application-row"
                  >
                    <div fxFlex="grow">
                      <label for="field-teamName"
                        >{{ getFieldLabel(fieldName.TeamName, 'Team Name') }}
                        @if (isRequired.TeamName) {
                          <span class="required">*</span>
                        }
                      </label>
                      <mat-form-field
                        appearance="outline"
                        floatLabel="auto"
                        [class.field-readonly]="!isRequired.TeamName"
                      >
                        <input
                          matInput
                          [readonly]="!isRequired.TeamName"
                          [attr.aria-disabled]="!isRequired.TeamName"
                          forbidAngleBrackets
                          id="field-teamName"
                          type="text"
                          formControlName="teamName"
                          [required-aria]="isRequired.TeamName"
                          (change)="updateFieldValidatorStatus(page)"
                        />
                        @if (teamGroup.controls.teamName.hasError('notEmpty')) {
                          <mat-error>
                            {{
                              teamGroup.controls.teamName.getError('notEmpty')
                            }}
                          </mat-error>
                        }
                        @if (
                          teamGroup.controls.teamName.hasError('maxlength')
                        ) {
                          <mat-error>
                            {{
                              getFailedValidationMessage(
                                'teamName',
                                'maxlength'
                              )
                            }}
                          </mat-error>
                        }
                        @if (
                          teamGroup.controls.teamName?.hasError(
                            'teamNameNotUnique'
                          )
                        ) {
                          <mat-error>
                            {{
                              teamGroup.controls.teamName.getError(
                                'teamNameNotUnique'
                              )
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    @if (!this.isHidden.TeamPublicName) {
                      <div fxFlex="grow">
                        <label for="field-teamPublicName">{{
                          getFieldLabel(
                            fieldName.TeamPublicName,
                            'Team Public Name'
                          )
                        }}</label>
                        <mat-form-field
                          appearance="outline"
                          floatLabel="always"
                          [class.field-readonly]="!isRequired.TeamName"
                        >
                          <input
                            matInput
                            [readonly]="!isRequired.TeamName"
                            [attr.aria-disabled]="!isRequired.TeamName"
                            forbidAngleBrackets
                            id="field-teamPublicName"
                            type="text"
                            formControlName="teamPublicName"
                            placeholder=""
                            (change)="updateFieldValidatorStatus(page)"
                          />
                          @if (
                            teamGroup.controls.teamPublicName.hasError(
                              'maxlength'
                            )
                          ) {
                            <mat-error>
                              {{
                                getFailedValidationMessage(
                                  'teamPublicName',
                                  'maxlength'
                                )
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                  </div>
                  @if (addressHelper) {
                    <address
                      class="mb-20"
                      [addressHelper]="addressHelper"
                      [validateAddress]="form.validateAddress"
                      (addressUpdated)="addressUpdated(page)"
                    >
                      <h3 class="sub-title">Mailing Address</h3>
                    </address>
                  }
                </div>
              </form>
            } @else {
              <form [formGroup]="applicationForm">
                <div fxLayout="column">
                  @if (!isHidden.Avatar) {
                    <div
                      [id]="fieldName.Avatar"
                      fxLayoutAlign="center center"
                      fxLayout="column"
                    >
                      <cloudinary-upload
                        [imageChangedCallback]="
                          imageChangedCallbackReference(page)
                        "
                        [errorCallback]="imageErrorCallbackReference()"
                        [image]="image"
                        [alwaysShowIcons]="true"
                        [required]="isRequired.Avatar"
                        [showRequiredError]="showAvatarRequiredError"
                        (blurred)="onAvatarBlur()"
                      ></cloudinary-upload>
                    </div>
                  }
                  <div
                    class="cloudinary-error-container"
                    fxLayoutAlign="center center"
                  >
                    @if (this.errorMessage) {
                      <label class="cloudinary-error-message">{{
                        this.errorMessage
                      }}</label>
                    }
                  </div>
                  <div
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                    fxLayoutAlign="space-between"
                    fxLayoutGap="10px"
                    class="application-row"
                  >
                    @if (!isHidden.Prefix) {
                      <div class="suffix">
                        <label for="field-prefix"
                          >Prefix
                          @if (isRequired.Prefix) {
                            <span class="required"> *</span>
                          }
                        </label>
                        <mat-form-field
                          appearance="outline"
                          floatLabel="always"
                        >
                          <input
                            matInput
                            forbidAngleBrackets
                            type="text"
                            formControlName="prefix"
                            id="field-prefix"
                            autocomplete="prefix"
                            [placeholder]="isRequired.Prefix ? 'Required' : ''"
                            (change)="updateFieldValidatorStatus(page)"
                          />
                          @if (
                            applicationForm.controls.prefix.hasError('notEmpty')
                          ) {
                            <mat-error>
                              {{
                                applicationForm.controls.prefix.getError(
                                  'notEmpty'
                                )
                              }}
                            </mat-error>
                          }
                          @if (
                            applicationForm.controls.prefix.hasError(
                              'maxlength'
                            )
                          ) {
                            <mat-error>
                              {{
                                getFailedValidationMessage(
                                  'prefix',
                                  'maxlength'
                                )
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    <div fxFlex="grow" class="name">
                      <label for="field-firstName"
                        >First name <span class="required">*</span></label
                      >
                      <mat-form-field appearance="outline" floatLabel="auto">
                        <input
                          matInput
                          forbidAngleBrackets
                          id="field-firstName"
                          type="text"
                          formControlName="firstName"
                          autocomplete="given-name"
                          [required-aria]="true"
                          (change)="updateFieldValidatorStatus(page)"
                        />
                        @if (
                          applicationForm.controls.firstName.hasError(
                            'notEmpty'
                          )
                        ) {
                          <mat-error>
                            {{
                              applicationForm.controls.firstName.getError(
                                'notEmpty'
                              )
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    @if (!isHidden.MiddleName) {
                      <div fxFlex="grow" class="name">
                        <label for="field-middleName"
                          >Middle name
                          @if (isRequired.MiddleName) {
                            <span class="required"> *</span>
                          }
                        </label>
                        <mat-form-field
                          appearance="outline"
                          floatLabel="always"
                        >
                          <input
                            matInput
                            forbidAngleBrackets
                            type="text"
                            formControlName="middleName"
                            id="field-middleName"
                            autocomplete="additional-name"
                            [placeholder]="
                              isRequired.MiddleName ? 'Required' : ''
                            "
                            (change)="updateFieldValidatorStatus(page)"
                          />
                          @if (
                            applicationForm.controls.middleName.hasError(
                              'notEmpty'
                            )
                          ) {
                            <mat-error>
                              {{
                                applicationForm.controls.middleName.getError(
                                  'notEmpty'
                                )
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    <div fxFlex="grow" class="name">
                      <label for="field-lastName"
                        >Last name <span class="required">*</span></label
                      >
                      <mat-form-field appearance="outline" floatLabel="auto">
                        <input
                          matInput
                          forbidAngleBrackets
                          type="text"
                          formControlName="lastName"
                          id="field-lastName"
                          autocomplete="family-name"
                          [required-aria]="true"
                          (change)="updateFieldValidatorStatus(page)"
                        />
                        @if (
                          applicationForm.controls.lastName.hasError('notEmpty')
                        ) {
                          <mat-error>
                            {{
                              applicationForm.controls.lastName.getError(
                                'notEmpty'
                              )
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    @if (!isHidden.Suffix) {
                      <div class="suffix">
                        <label for="field-suffix"
                          >Suffix
                          @if (isRequired.Suffix) {
                            <span class="required"> *</span>
                          }
                        </label>
                        <mat-form-field
                          appearance="outline"
                          floatLabel="always"
                        >
                          <input
                            matInput
                            forbidAngleBrackets
                            type="text"
                            formControlName="suffix"
                            id="field-suffix"
                            autocomplete="suffix"
                            [placeholder]="isRequired.Suffix ? 'Required' : ''"
                            (change)="updateFieldValidatorStatus(page)"
                          />
                          @if (
                            applicationForm.controls.suffix.hasError('notEmpty')
                          ) {
                            <mat-error>
                              {{
                                applicationForm.controls.suffix.getError(
                                  'notEmpty'
                                )
                              }}
                            </mat-error>
                          }
                          @if (
                            applicationForm.controls.suffix.hasError(
                              'maxlength'
                            )
                          ) {
                            <mat-error>
                              {{
                                getFailedValidationMessage(
                                  'suffix',
                                  'maxlength'
                                )
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                  </div>
                  <div class="email-editor">
                    <h3 class="sub-title">Email</h3>
                    <app-email-editor
                      [readOnly]="true"
                      [ignoreVerification]="true"
                      [ignoreAlertModals]="true"
                      [primaryEmail]="person.email"
                      [secondaryEmails]="person.secondaryEmails"
                      [addFn]="addEmailFn"
                      [makePrimaryFn]="makePrimaryFn"
                      [deleteFn]="deleteEmailFn"
                    ></app-email-editor>
                  </div>

                  @if (!isHidden.PhoneNumber) {
                    <lib-phone
                      label="Phone Number"
                      [formGroup]="$any(applicationForm)"
                      [required]="isRequired.PhoneNumber"
                    >
                    </lib-phone>
                  }
                  @if (addressHelper) {
                    <address
                      class="mb-20"
                      [addressHelper]="addressHelper"
                      [validateAddress]="form.validateAddress"
                      (addressUpdated)="addressUpdated(page)"
                    >
                      <h3 class="sub-title">Mailing Address</h3>
                    </address>
                  }
                  @if (!isHidden.Gender || !isHidden.Race) {
                    <h3 class="sub-title">
                      Demographics Information
                      {{
                        !isRequired.Race && !isRequired.Gender
                          ? '(Optional)'
                          : ''
                      }}
                    </h3>
                    <div
                      id="races"
                      fxLayout="column"
                      fxLayout.gt-xs="row"
                      fxLayoutAlign="space-between"
                      class="application-row demographics-row"
                    >
                      @if (!isHidden.Race) {
                        <div fxFlex="50">
                          <div>
                            Race/Ethnicity (select all that apply)
                            @if (isRequired.Race) {
                              <span class="required"> *</span>
                            }
                          </div>
                          <div
                            fxLayout="column"
                            fxLayoutAlign="space-between"
                            [ngClass]="
                              applicationForm.controls.races.touched &&
                              applicationForm.controls.races.hasError(
                                'notEmpty'
                              )
                                ? 'race-group-error'
                                : 'race-group'
                            "
                            role="group"
                            aria-label="What is your race or ethnicity? Select all that apply."
                          >
                            <div class="checkbox-required-text">
                              @if (isRequired.Race) {
                                <div>Required</div>
                              }
                            </div>
                            @for (race of races; track race.id) {
                              <mat-checkbox
                                class="checkbox-label"
                                color="primary"
                                (change)="
                                  updateRace(race, $event);
                                  updateFieldValidatorStatus(page)
                                "
                                [checked]="getRaceCheckboxStatus(race)"
                              >
                                {{ race.name }}
                              </mat-checkbox>
                            }
                            @if (
                              applicationForm.controls.races.touched &&
                              applicationForm.controls.races.hasError(
                                'notEmpty'
                              )
                            ) {
                              <label
                                class="race-error-message"
                                [attr.aria-label]="
                                  getFailedValidationMessage(
                                    'races',
                                    'notEmpty'
                                  )
                                "
                              >
                                {{
                                  getFailedValidationMessage(
                                    'races',
                                    'notEmpty'
                                  )
                                }}
                              </label>
                            }
                          </div>
                        </div>
                      }
                      @if (!isHidden.Gender) {
                        <div fxFlex>
                          <div>
                            Gender Identity
                            @if (isRequired.Gender) {
                              <span class="required"> *</span>
                            }
                          </div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="always"
                          >
                            <mat-select
                              [placeholder]="
                                isRequired.Gender ? 'Required' : 'Gender'
                              "
                              formControlName="gender"
                              aria-label="What is your gender identity"
                              (selectionChange)="
                                updateFieldValidatorStatus(page)
                              "
                            >
                              <mat-option [value]="">Select</mat-option>
                              <mat-option [value]="gender.Female"
                                >Female</mat-option
                              >
                              <mat-option [value]="gender.Male"
                                >Male</mat-option
                              >
                              @if (isGenderSelectable('NonBinary')) {
                                <mat-option [value]="gender.NonBinary"
                                  >Non-binary</mat-option
                                >
                              }
                              @if (isGenderSelectable('PreferNotToAnswer')) {
                                <mat-option [value]="gender.PreferNotToAnswer"
                                  >Prefer not to answer</mat-option
                                >
                              }
                            </mat-select>
                            @if (
                              applicationForm.controls.gender.touched &&
                              applicationForm.controls.gender.hasError(
                                'notEmpty'
                              )
                            ) {
                              <mat-error
                                [attr.aria-label]="
                                  getFailedValidationMessage(
                                    'gender',
                                    'notEmpty'
                                  )
                                "
                              >
                                {{
                                  getFailedValidationMessage(
                                    'gender',
                                    'notEmpty'
                                  )
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                </div>
              </form>
              @if (isProfessionalInformationVisible) {
                <form [formGroup]="applicationForm" fxLayout="column">
                  <h3 class="sub-title">Professional Information</h3>
                  <div class="step-content">
                    <div
                      fxLayout="column"
                      fxLayout.gt-xs="row"
                      fxLayoutAlign="space-between"
                      fxLayoutGap="20px"
                      class="application-row"
                    >
                      @if (!isHidden.JobTitle) {
                        <div fxFlex>
                          <label for="field-jobTitle">
                            Job Title
                            @if (isRequired.JobTitle) {
                              <span class="required"> *</span>
                            }
                          </label>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="always"
                          >
                            <input
                              matInput
                              forbidAngleBrackets
                              type="text"
                              formControlName="jobTitle"
                              id="field-jobTitle"
                              [placeholder]="
                                isRequired.JobTitle ? 'Required' : ''
                              "
                              autocomplete="organization-title"
                              (change)="updateFieldValidatorStatus(page)"
                            />
                            @if (
                              applicationForm.controls.jobTitle.hasError(
                                'notEmpty'
                              )
                            ) {
                              <mat-error>
                                {{
                                  applicationForm.controls.jobTitle.getError(
                                    'notEmpty'
                                  )
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                      @if (!isHidden.Company) {
                        <div fxFlex>
                          <label for="field-company">
                            Company
                            @if (isRequired.Company) {
                              <span class="required"> *</span>
                            }
                          </label>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="always"
                          >
                            <input
                              matInput
                              forbidAngleBrackets
                              type="text"
                              formControlName="company"
                              id="field-company"
                              [placeholder]="
                                isRequired.Company ? 'Required' : ''
                              "
                              autocomplete="organization"
                              (change)="updateFieldValidatorStatus(page)"
                            />
                            @if (
                              applicationForm.controls.company.hasError(
                                'notEmpty'
                              )
                            ) {
                              <mat-error>
                                {{
                                  applicationForm.controls.company.getError(
                                    'notEmpty'
                                  )
                                }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                    </div>
                    @if (!isHidden.LinkedIn) {
                      <div
                        fxLayoutAlign="space-between"
                        fxLayout="column"
                        class="application-row ms-block"
                      >
                        <label for="field-linkedInProfile"
                          >LinkedIn Profile
                          @if (isRequired.LinkedIn) {
                            <span class="required"> *</span>
                          }
                        </label>
                        <mat-form-field
                          appearance="outline"
                          floatLabel="always"
                          fxFlex="100%"
                        >
                          <input
                            matInput
                            forbidAngleBrackets
                            type="text"
                            formControlName="linkedInProfile"
                            placeholder="LinkedIn Profile"
                            (change)="updateFieldValidatorStatus(page)"
                          />
                          @if (
                            applicationForm.controls.linkedInProfile.hasError(
                              'urlPattern'
                            ) &&
                            applicationForm.controls.linkedInProfile.touched
                          ) {
                            <mat-error>
                              {{
                                getFailedValidationMessage(
                                  'linkedInProfile',
                                  'urlPattern'
                                )
                              }}
                            </mat-error>
                          }
                          @if (
                            applicationForm.controls.linkedInProfile.hasError(
                              'notEmpty'
                            )
                          ) {
                            <mat-error>
                              {{
                                applicationForm.controls.linkedInProfile.getError(
                                  'notEmpty'
                                )
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (isResumeVisible) {
                      <div
                        fxLayoutAlign="space-between"
                        fxLayout="column"
                        class="application-row ms-block"
                      >
                        <span
                          >Resume or Curriculum Vitae
                          @if (isRequired.Resume) {
                            <span class="required"> *</span>
                          }
                        </span>
                        <mat-form-field
                          class="upload-resume-cv-field"
                          appearance="outline"
                          floatLabel="always"
                          fxFlex="100%"
                        >
                          <input
                            matInput
                            type="text"
                            readonly="true"
                            formControlName="resumeUpload"
                            aria-hidden="true"
                            tabindex="-1"
                          />
                          <div fxFlex fxLayout="row" fxLayoutAlign="end">
                            <document-upload
                              #uploadResume
                              [doUpload]="false"
                              [doScan]="inPreviewMode ? false : true"
                              [onFileUpload]="onResumeUpload()"
                              [displayUploadButton]="
                                displayUploadAndDeleteButtons
                              "
                              (virusScanResultEvent)="
                                processVirusScanResults($event, page)
                              "
                              uploadText="Upload"
                              uploadButtonClass="mat-custom"
                              class="upload-resume"
                              uploadAriaLabel="Upload Resume or Curriculum Vitae"
                            ></document-upload>
                            @if (!noResumeUploaded()) {
                              <button
                                mat-icon-button
                                (click)="onResumeClear()"
                                type="button"
                                aria-label="Delete uploaded file"
                              >
                                @if (displayUploadAndDeleteButtons) {
                                  <mat-icon>delete</mat-icon>
                                }
                              </button>
                            }
                          </div>
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'notEmpty'
                            )
                          ) {
                            <mat-error>
                              {{
                                applicationForm.controls.resumeUpload.getError(
                                  'notEmpty'
                                )
                              }}
                            </mat-error>
                          }
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'documentFailedScan'
                            )
                          ) {
                            <mat-error>
                              {{ this.uploadErrorMessage }}
                            </mat-error>
                          }
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'documentScanRequestFailed'
                            )
                          ) {
                            <mat-error>
                              {{ this.uploadErrorMessage }}
                            </mat-error>
                          }
                        </mat-form-field>
                        <div aria-live="polite" class="cdk-visually-hidden">
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'notEmpty'
                            )
                          ) {
                            <span>
                              {{
                                applicationForm.controls.resumeUpload.getError(
                                  'notEmpty'
                                )
                              }}
                            </span>
                          }
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'documentFailedScan'
                            )
                          ) {
                            <span>
                              {{ this.uploadErrorMessage }}
                            </span>
                          }
                          @if (
                            applicationForm.controls.resumeUpload.hasError(
                              'documentScanRequestFailed'
                            )
                          ) {
                            <span>
                              {{ this.uploadErrorMessage }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </form>
              }
            }
          } @else {
            <mat-divider class="page-divider"></mat-divider>
          }
          @if (activePage.id == page.id) {
            <attributes-editor
              #attributesEditor
              fxFlexWidth="100%"
              [formPage]="activePage"
              [dataSource]="attributesEditorDataSource"
              [useAttributeDescription]="true"
              [secureLinkId]="secureLinkId"
              [mode]="mode"
              [isPrivate]="form.isPrivate"
              (fieldUpdated)="updateFieldValidatorStatus(page)"
              (downloadFile)="downloadFile($event)"
            >
            </attributes-editor>
          }
          @if (!isSinglePagePreview) {
            @if (totalPages === 1) {
              <div
                class="button-section"
                fxFlex
                fxLayout="column"
                fxLayoutAlign="center center"
              >
                <validation-summary
                  [failedValidations]="formFailedValidations"
                  label="form"
                >
                </validation-summary>
                <div class="submit-instructions">
                  <em
                    >You are submitting this application as
                    <b>{{ application?.email }}.</b><br />
                    Not you?
                    <a
                      target="_blank"
                      href="{{ form?.requestUri }}"
                      aria-label="Access your personalized application"
                      >Click here</a
                    >
                    to access your personalized application.
                  </em>
                </div>

                <div
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  fxLayoutGap="10px"
                >
                  <ng-container
                    [ngTemplateOutlet]="submitButton"
                  ></ng-container>
                  @if (isPortalForm) {
                    <button
                      mat-flat-button
                      type="button"
                      class="back-button mr-1 ml-1"
                      (click)="saveAndExit()"
                    >
                      Save & Close
                    </button>
                  }
                </div>
              </div>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  buttonBar;
                  context: { i: i, page: page, isLast: i === totalPages - 1 }
                "
              ></ng-container>
            }
          }
        </mat-step>
      }
      @if (positionsPageIndex) {
        <mat-step [completed]="isFormValid()">
          <h2 class="font-24 mb-20">Positions</h2>
          <div class="position-pickers">
            @for (position of application.positions; track position.id) {
              <app-position-person-picker
                [position]="position"
                [isTouched]="isTouched"
                [initialSelectedPersonIds]="
                  selectedPositionPersonIds[position.id]
                "
                [invalidPositionPersonIds]="invalidPositionPersonIds"
                [initialSeatFieldValues]="
                  seatFieldValuesForPosition(position.id)
                "
                (personIdsChange)="
                  onPositionPersonIdsChange(position.id, $event)
                "
                (seatFieldValuesChange)="
                  onPositionSeatFieldValuesChange(position.id, $event)
                "
              ></app-position-person-picker>
            }
          </div>
          <ng-container
            *ngTemplateOutlet="
              buttonBar;
              context: {
                i: positionsPageIndex,
                isLast: positionsPageIndex === totalPages - 1
              }
            "
          ></ng-container>
        </mat-step>
      }
      @if (hasPaymentPage) {
        <mat-step>
          <application-payment
            [inPreviewMode]="inPreviewMode"
            [previewFormId]="previewFormId"
          ></application-payment>

          <ng-container
            *ngTemplateOutlet="
              buttonBar;
              context: { i: totalPages - 1, isLast: true }
            "
          ></ng-container>
        </mat-step>
      }

      <ng-template #buttonBar let-i="i" let-page="page" let-isLast="isLast">
        <div
          class="button-section"
          fxFlex
          fxLayout="column"
          fxLayoutAlign="center stretch"
        >
          @if (isLast || !page) {
            <validation-summary
              [failedValidations]="formFailedValidations"
              label="form"
            >
            </validation-summary>
            <div class="submit-instructions">
              <em
                >You are submitting this application as
                <b>{{ application?.email }}.</b><br />
                Not you?
                <a
                  target="_blank"
                  href="{{ form?.requestUri }}"
                  aria-label="Access your personalized application"
                  >Click here</a
                >
                to access your personalized application.
              </em>
            </div>
          } @else if (page) {
            <validation-summary
              [failedValidations]="pageFailedValidations"
              label="page"
            >
            </validation-summary>
          }

          <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex fxLayoutAlign="end none" class="nav-right">
              @if (isLast) {
                <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
              } @else {
                <button
                  mat-flat-button
                  type="button"
                  class="mat-primary next-button"
                  (click)="onNextClick(page)"
                  matStepperNext
                >
                  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <span>Next</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </div>
                </button>
              }
              @if (isPortalForm) {
                <button
                  mat-flat-button
                  type="button"
                  class="back-button mr-1 ml-1"
                  (click)="saveAndExit()"
                >
                  Save & Close
                </button>
              }
            </div>
            <div class="nav-center">Page {{ i + 1 }} of {{ totalPages }}</div>
            <div fxFlex fxLayoutAlign="start none" class="nav-left">
              @if (i !== 0) {
                <button
                  id="figure-out-id"
                  mat-flat-button
                  type="button"
                  fxLayoutAlign="start none"
                  matStepperPrevious
                  class="back-button"
                  (click)="onBackClick()"
                >
                  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      </ng-template>
    </mat-stepper>
  </div>
</div>

<ng-template #submitButton>
  <button
    id="submit-button-last"
    mat-flat-button
    type="button"
    class="mat-primary submit-button"
    [disabled]="disableSubmit"
    appThrottleClick
    (throttledClick)="submitApplication()"
  >
    <div fxFlex fxLayout="row" fxLayoutAlign="center center">
      <mat-icon>done</mat-icon>
      <span>Submit</span>
    </div>
  </button>
</ng-template>
